import { HttpErrorResponse } from '@angular/common/http';
import { ICompanyDTO, ICompanyNameIdLegalFormDTO } from '@modeso/types__aumico-lib-companies-be';
import { Observable } from 'rxjs';
import { ICompanyExportDto } from '../dtos/company-export-dto.interface';
import { ICompanyExportTableHeaders } from '../dtos/company-export-table-header-dto.interface';
import { TasksUpdate } from '../enums/tasks-update.enum';

export interface ICompaniesProvider {
    createCompany(company: ICompanyDTO, logo: File | null, activateFx?: boolean);
    dispatchUpdateCompany(company: ICompanyDTO, logo: File | null, tasksUpdate?: TasksUpdate);
    dispatchBulkUpdateCompanies(companies: ICompanyDTO[], logo: File | null, tasksUpdate?: TasksUpdate);
    dispatchUpdateCompanyStatus(active: boolean, id: string);
    dispatchDeleteCompany(id: string);
    dispatchCompaniesList();
    getCompanies$(): Observable<ICompanyDTO[]>;
    dispatchCompanyById(id: string);
    getCompanyCreationResponse$(): Observable<{ company: ICompanyDTO }>;
    getSelectedCompanyById$(): Observable<ICompanyDTO>;
    getCompaniesResponse$(): Observable<ICompanyDTO>;
    resetCompanies(): void;
    resetErrors(): void;
    getCompaniesNameIdLegalForm$(): Observable<ICompanyNameIdLegalFormDTO[]>;
    isCompanyUrlIdValid$(id: string): Observable<boolean>;
    dispatchExportCompaniesDataAsExcel(
        tableHeaders: ICompanyExportTableHeaders,
        companies: ICompanyExportDto[],
        fileName: string,
    ): void;
    getDeleteCompanyResult$(): Observable<any>;
    getBulkUpdateCompaniesResult$(): Observable<
        | { type: string; payload: ICompanyDTO[] }
        | { type: string; payload: HttpErrorResponse }
    >;
}
